/**
 * @fileoverview Agent definition for continuity-committee-v2.
 *
 * This is a COMPOSITE agent that orchestrates three specialized continuity
 * checker agents in parallel to provide a full continuity audit:
 * 1. chapter-continuity-checker-v2: Plot, timeline, and logic continuity
 * 2. character-continuity-checker-v2: Character voice, traits, and relationships
 * 3. item-continuity-checker-v2: Physical objects, their states, and existence
 *
 * @category narrative.prose.review
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'continuity-committee-v2',
  kind: 'composite',
  name: 'Continuity Committee',
  description: 'Runs three specialized continuity checker agents in parallel to audit a chapter for plot/timeline, character, and item continuity issues.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    usedBy: [
      'use-continuity-committee-v2.ts',
    ],
    composedOf: [
      'chapter-continuity-checker-v2',
      'character-continuity-checker-v2',
      'item-continuity-checker-v2',
    ],
    relatedAgents: [
      'chapter-continuity-checker-v2',
      'character-continuity-checker-v2',
      'item-continuity-checker-v2',
      'critique-committee-v2',
    ],
    taxonomyPath: 'narrative.prose.review',
  },
};
